import type { BulkOperationType } from '@/components/TableView';

export const BULK_OPERATION_TYPES: {
  PUBLISH: BulkOperationType;
  DISCARD: BulkOperationType;
  EDIT: BulkOperationType;
} = {
  PUBLISH: 'publish',
  DISCARD: 'discard',
  EDIT: 'edit'
};
